/* ══ THE DEVICE'S OWN CALENDAR DATE — STEP 6, STOP D (2026-10-03) ═════
 *
 * ⚠ THE DEFECT, found 2026-09-26 by the step 6 renders and on production
 * since Phase 1: both add paths stamped "Acquired" with
 * `new Date().toISOString().slice(0,10)`, which is the UTC date. At
 * 20:09 EDT on 2026-09-26 (00:09 UTC on the 27th) a note added that
 * evening read 27.09.2026. For a collector in the Americas any note added
 * after the local offset past midnight UTC (8 pm Eastern in summer) was
 * dated tomorrow; east of UTC (Pacific/Auckland) a morning add was dated
 * yesterday. ⚠ US Pacific time can never read the previous day — UTC is
 * ahead of it — so the register's "in the Pacific a morning add can be
 * dated the previous day" is true of the UTC+ Pacific, not of California;
 * measured 2026-10-03, and the gate pins both sides.
 *
 * His rulings: the device's local calendar date in both add paths (the
 * 2026-09-27 review of the 6.3 renders, item (b)); *"Leave stored Acquired
 * dates as they are."* (his answer 6) — so nothing here touches a date
 * already written, and `mapper.js` still refuses anything but YYYY-MM-DD.
 *
 * Pure: no imports, no DOM. `d` is for the gate, which fixes the clock;
 * the app never passes one.
 */
const pad2 = (n) => String(n).padStart(2, '0')

/** The calendar date where the device is, as `YYYY-MM-DD` — the local
 *  year, month and day, never the UTC ones. */
export function localDate(d = new Date()) {
  /* concatenated, not a template literal, so the twin's anchors carry no `${` and anchor-sweep checks them */
  return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate())
}
